import { get } from 'lodash'

import { types } from './industryCertificate.actions'
import {
  CertificationsDetailsType,
  CertificationsType
} from 'types/IndustryCertifications.types'
import { INITIAL_STATE_DETAILS } from 'constants/certifications.constants'

type Certificate = {
  certificates: {
    items: CertificationsType[]
    pagination: {
      totalItems: number
      limit: number
      page: number
    }
  }
  certificate?: CertificationsDetailsType
  loading: boolean
}

const INITIAL_STATE = {
  certificates: {
    items: [],
    pagination: null
  },
  certificate: INITIAL_STATE_DETAILS as CertificationsDetailsType,
  loading: false
}

function setState(state: Certificate) {
  return function _handle(payload: Record<string, any>) {
    return { ...state, ...payload }
  }
}

export default function _reducer(state = INITIAL_STATE, { type, payload }) {
  const _handlers = {
    [types.SET_CERTIFICATES]: setState(state),
    [types.SET_CERTIFICATE]: setState(state),
    _default: () => state
  }

  return get(_handlers, type, _handlers._default)(payload)
}
